// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"5c48c416","684":"ab8600d4"}[chunkId] + ".chunk.js";
};